// extracted by mini-css-extract-plugin
export default {"soft_buy":"DiscountPrice_soft_buy__W7iT2","btn":"DiscountPrice_btn__qr9hg","btn_tag":"DiscountPrice_btn_tag__ELpma"};